import Commands from "./commands";

class Sub extends Commands {
    constructor(registry) {
        super("sub", registry);
    }

    async execute(node, emitter, options) {
        const param1 = await emitter(node.params[0], options);
        const param2 = await emitter(node.params[1], options);
        if (typeof (param1) !== typeof (param2)) {
            console.error("Params type are not the same");
            return undefined;
        }
        if (param1 instanceof Date && param2 instanceof Date) {
            return param1 - param2;
        }
        return parseFloat(param1) - parseFloat(param2);
    }
}

export default Sub;
